var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiPagination from '@material-ui/lab/Pagination';
/**
 * Kareo wrapped component of the Material-UI Pagination. The prop API has been limited to props defined in PaginationProps.
 *
 * The Pagination component enables the user to select a specific page from a range of pages.
 *
 * Material-UI Pagination: [Docs](https://v4.mui.com/components/pagination/), [API](https://v4.mui.com/api/pagination/)
 *
 * @storybook: [Pagination](http://design.kareoprod.ent/design-system/?path=/story/components-data-display--pagination)
 */
var Pagination = React.forwardRef(function (props, ref) {
    return React.createElement(MuiPagination, __assign({}, props, { ref: ref }));
});
Pagination.defaultProps = {};
Pagination.displayName = 'KareoPagination';
export default Pagination;
